module.exports = __webpack_public_path__ + "media/bootstrap-icons/bar-chart-line-fill-0db5535b.svg";